import ThemeColor from './theme_color';

export default ThemeColor;



// WEBPACK FOOTER //
// ./src/components/ThemeColor/index.js